import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { OffersService } from 'src/app/services/offers/offers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConstantService } from 'src/app/services/constant/constant.service';

@Component({
  selector: 'app-available-services',
  templateUrl: './available-services.component.html',
  styleUrls: ['./available-services.component.scss'],
})
export class AvailableServicesComponent implements OnInit {
  loadingSpinner = false;
  Load = false;

  enterprise: any;

  // payment champ
  cardNumber = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(14),
    Validators.maxLength(26),
  ]);
  expDate = new UntypedFormControl('', [Validators.required]);
  cvCode = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(3),
    Validators.pattern('[0-9]*'),
  ]);
  paymentForm: UntypedFormGroup;
  cardToken: any;
  offerItem: any;
  langueStorage: any;
  today: any;
  defaultService = '../assets/images/offer_default.png';
  currentOffer: any;
  isStart = false;
  emptyBadgeOffers = false;
  emptyTutorialOffers = false;
  emptyXchangeOffers = false;
  emptyApkOffers = false;
  emptySupportOffers = false;
  badges = [];
  apk = [];
  xchange = [];
  tutorial = [];
  support = [];
  params;

  isContractActive: boolean;

  setActiveBadge = true;
  setActiveMobile = false;
  setActiveXchange = false;
  setActiveSupport = false;

  displayActiveModal = false;
  displayDisableeModal = false;
  displayReactiveModal = false;

  dataDialog;
  currentEnterpriseCurrency: string;

  constructor(
    private readonly constantService: ConstantService,
    private readonly offerService: OffersService,
    private readonly storageService: CustomStorageService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly authService: AuthService,
    private readonly ref: ChangeDetectorRef,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isContractActive = JSON.parse(localStorage.getItem('enterprise')).hasActiveContract;
    this.route.queryParams
    .subscribe((params) => {
     if (params) {
      switch (params['service']) {
        case 'mobile':
          this.setActiveBadge = false;
          this.setActiveMobile = true;
          this.setActiveXchange = false;
          this.setActiveSupport = false;
          break;
        case 'xchange':
          this.setActiveBadge = false;
          this.setActiveMobile = false;
          this.setActiveXchange = true;
          this.setActiveSupport = false;
          break;
        case 'support':
          this.setActiveBadge = false;
          this.setActiveMobile = false;
          this.setActiveXchange = false;
          this.setActiveSupport = true;
          break;
        default:
          this.setActiveBadge = true;
          this.setActiveMobile = false;
          this.setActiveXchange = false;
          this.setActiveSupport = false;
          break;
      }
     }
    });

    this.today = new Date();
    this.langueStorage = localStorage.getItem('storage-language').toUpperCase();
    this.loadDataOffer();
    this.enterprise = this.storageService.getEnterprise();
    // this.currentEnterpriseCurrency = this.constantService.getCurrencySymbol(this.enterprise.currency) ;
    this.currentEnterpriseCurrency = '€' ;
    // payment form init
    this.paymentForm = this.formBuilder.group({
      cardNumber: this.cardNumber,
      expDate: this.expDate,
      cvCode: this.cvCode,
      currencies: ['eur'],
    });
  }

  // eslint-disable-next-line
  ngAfterViewInit() {
    this.langueStorage = localStorage.getItem('storage-language').toUpperCase();
    this.loadDataOffer();
    this.ref.detectChanges();
  }

  loadDataOffer() {
    this.langueStorage = localStorage.getItem('storage-language').toUpperCase();
    this.loadingSpinner = true;
    this.ref.detectChanges();
    this.offerService.getOffers().subscribe(
      (data: any) => {
        this.loadingSpinner = false;
        this.formateDataOffers(data.data);
        // localStorage.setItem("offer", JSON.stringify(this.offers));
      },
      (error) => {
        this.loadingSpinner = false;
        this.constantService.showErrorToast('toast.error_server');
      }
    );
  }

  formateDataOffers(offers) {
    this.formateBadges(offers);
    this.formateApk(offers);
    this.formateSupport(offers);
    this.formateTutorial(offers);
    this.formateXchange(offers);
  }

  formateBadges(offers) {
    this.badges = [];
    if (offers.badges.length === 0) {
      this.emptyBadgeOffers = true;
    } else {
      this.emptyBadgeOffers = false;
      offers.badges.forEach(row => {
        this.badges.push(
          {
            id: row._id,
            updatedAt: row.updatedAt ? row.updatedAt : '--',
            isAvailable: row.isAvailable,
            isSubscribed: row.isSubscribed,
            isDeleted: row.isDeleted,
            photo: row.photo && row.photo !== 'null' ? row.photo : this.defaultService,
            subscription: row.subscription ? row.subscription : '--',
            price: row.price ? row.price.toFixed(2) + (row.currency ? row.currency : this.currentEnterpriseCurrency) : 0,
            title: this.filterLanguageTitle(this.langueStorage, row),
            description: this.filterLanguageDesc(this.langueStorage, row)
          }
        );
      });
      this.badges = this.badges.filter((x) => ((x.subscription.isActive && x.isSubscribed) || x.isAvailable || x.isSubscribed));
      this.badges = this.badges.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
      if (this.badges.length === 0) {
        this.emptyBadgeOffers = true;
      }
    }
  }

  formateApk(offers) {
    this.apk = [];
    if (offers.custom_mobile_app.length === 0) {
      this.emptyApkOffers = true;
    } else {
      this.emptyApkOffers = false;
      offers.custom_mobile_app.forEach(row => {
        this.apk.push(
          {
            id: row._id,
            updatedAt: row.updatedAt ? row.updatedAt : '--',
            isAvailable: row.isAvailable,
            isSubscribed: row.isSubscribed,
            photo: row.photo && row.photo !== 'null' ? row.photo : this.defaultService,
            subscription: row.subscription ? row.subscription : '--',
            isDeleted: row.isDeleted,
            price: row.price ? row.price.toFixed(2) + (row.currency ? row.currency : this.currentEnterpriseCurrency) : 0,
            title: this.filterLanguageTitle(this.langueStorage, row),
            description: this.filterLanguageDesc(this.langueStorage, row)
          }
        );
      });
      this.apk = this.apk.filter((x) => ((x.subscription.isActive && x.isSubscribed) || x.isAvailable || x.isSubscribed));
      this.apk = this.apk.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
      if (this.apk.length === 0) {
        this.emptyApkOffers = true;
      }
    }
  }

  formateXchange(offers) {
    this.xchange = [];
    if (offers.xchange.length === 0) {
      this.emptyXchangeOffers = true;
    } else {
      this.emptyXchangeOffers = false;
      offers.xchange.forEach(row => {
        this.xchange.push(
          {
            id: row._id,
            updatedAt: row.updatedAt ? row.updatedAt : '--',
            isAvailable: row.isAvailable,
            isSubscribed: row.isSubscribed,
            photo: row.photo && row.photo !== 'null' ? row.photo : this.defaultService,
            subscription: row.subscription ? row.subscription : '--',
            isDeleted: row.isDeleted,
            price: row.price ? row.price.toFixed(2) + (row.currency ? row.currency : this.currentEnterpriseCurrency) : 0,
            title: this.filterLanguageTitle(this.langueStorage, row),
            description: this.filterLanguageDesc(this.langueStorage, row)
          }
        );
      });
      this.xchange = this.xchange.filter((x) => ((x.subscription.isActive && x.isSubscribed) || x.isAvailable || x.isSubscribed));
      this.xchange = this.xchange.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
      if (this.xchange.length === 0) {
        this.emptyXchangeOffers = true;
      }
    }
  }

  formateSupport(offers) {
    this.support = [];
    if (offers.support.length === 0) {
      this.emptySupportOffers = true;
    } else {
      this.emptySupportOffers = false;
      offers.support.forEach(row => {
        this.support.push(
          {
            id: row._id,
            updatedAt: row.updatedAt ? row.updatedAt : '--',
            isAvailable: row.isAvailable,
            isSubscribed: row.isSubscribed,
            photo: row.photo && row.photo !== 'null' ? row.photo : this.defaultService,
            subscription: row.subscription ? row.subscription : '--',
            isDeleted: row.isDeleted,
            price: row.price ? row.price.toFixed(2) + (row.currency ? row.currency : this.currentEnterpriseCurrency) : 0,
            title: this.filterLanguageTitle(this.langueStorage, row),
            description: this.filterLanguageDesc(this.langueStorage, row)
          }
        );
      });
      this.support = this.support.filter((x) => ((x.subscription.isActive && x.isSubscribed) || x.isAvailable || x.isSubscribed));
      this.support = this.support.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
      if (this.support.length === 0) {
        this.emptySupportOffers = true;
      }
    }
  }

  formateTutorial(offers) {
    this.tutorial = [];
    if (offers.tutorial.length === 0) {
      this.emptyTutorialOffers = true;
    } else {
      this.emptyTutorialOffers = false;
      offers.tutorial.forEach(row => {
        this.tutorial.push(
          {
            id: row._id,
            updatedAt: row.updatedAt ? row.updatedAt : '--',
            isAvailable: row.isAvailable,
            isSubscribed: row.isSubscribed,
            photo: row.photo && row.photo !== 'null' ? row.photo : this.defaultService,
            subscription: row.subscription ? row.subscription : '--',
            isDeleted: row.isDeleted,
            price: row.price ? row.price.toFixed(2) + (row.currency ? row.currency : this.currentEnterpriseCurrency) : 0,
            title: this.filterLanguageTitle(this.langueStorage, row),
            description: this.filterLanguageDesc(this.langueStorage, row)
          }
        );
      });
      this.tutorial = this.tutorial.filter((x) => ((x.subscription.isActive && x.isSubscribed) || x.isAvailable || x.isSubscribed));
      this.tutorial = this.tutorial.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
      if (this.tutorial.length === 0) {
        this.emptyTutorialOffers = true;
      }
    }
  }

  filterLanguageDesc(langueStorage, row) {
    let description = '';
    switch (langueStorage) {
      case 'FR': description = row.description[0].text;
        break;
      case 'EN': description = row.description[1].text;
        break;
      case 'ESP': description = row.description[2].text;
        break;
      case 'DE': description = row.description[3].text;
        break;
      default: description = row.description[0].text;
    }
    return description;
  }

  filterLanguageTitle(langueStorage, row) {
    let title = '';
    switch (langueStorage) {
      case 'FR': title = row.title[0].text;
        break;
      case 'EN': title = row.title[1].text;
        break;
      case 'ESP': title = row.title[2].text;
        break;
      case 'DE': title = row.title[3].text;
        break;
      default: title = row.title[0].text;
    }
    return title;
  }

  /**
   * function is called to active offer selected.
   */
  activeOffer() {
    this.Load = true;
    this.offerService.activateOffer(this.dataDialog.id).subscribe(
      (data) => {
        this.Load = false;
        this.loadDataOffer();
        this.getCurrentPack();
        this.constantService.showSuccessToast('toast.success_activate_offer');
      },
      (error) => {
        this.Load = false;
        switch (error.status) {
          case 401:
            this.authService.logout();
            break;
          case 403:
            this.constantService.showErrorToast('toast.error_permission_denied');
            break;
          case 409:
            this.constantService.showErrorToast('toast.error_action_offer_already_done');
            break;
          default:
            this.constantService.showErrorToast('toast.error_server');
            break;
        }
      }
    );
  }

  /**
   * function is called to disable offer selected.
   */
  disabledOffer() {
    this.Load = true;
    this.offerService.disabledOffer(this.dataDialog.subscription.id).subscribe(
      (data) => {
        this.Load = false;
        this.loadDataOffer();
        this.getCurrentPack();
        this.constantService.showSuccessToast('toast.success_deactivate_offer');
      },
      (error) => {
        this.Load = false;
        switch (error.status) {
          case 401:
            this.authService.logout();
            break;
          case 403:
            this.constantService.showErrorToast('toast.error_permission_denied');
            break;
          case 409:
            this.constantService.showErrorToast('toast.error_action_offer_already_done');
            break;
          default:
            this.constantService.showErrorToast('toast.error_server');
            break;
        }
      }
    );
  }

  /**
   * function is called to reactivate offer selected.
   */
  reactivateOffer() {
    this.Load = true;
    this.offerService.reactiveOffer(this.dataDialog.subscription.id).subscribe(
      (data) => {
        this.Load = false;
        this.loadDataOffer();
        this.getCurrentPack();
        this.constantService.showSuccessToast('toast.success_activate_offer');
      },
      (error) => {
        this.Load = false;
        switch (error.status) {
          case 401:
            this.authService.logout();
            break;
          case 403:
            this.constantService.showErrorToast('toast.error_permission_denied');
            break;
          case 409:
            this.constantService.showErrorToast('toast.error_action_offer_already_done');
            break;
          default:
            this.constantService.showErrorToast('toast.error_server');
            break;
        }
      }
    );
  }

  /**
   * function is called to get current offer
   */
  getCurrentPack() {
    this.offerService.getCurrentOffer().subscribe((data) => {
      this.currentOffer = data;
      localStorage.setItem('offer', JSON.stringify(this.currentOffer));
    });
  }

  /**
   * Function is called to open modal.
   */
   openDialog(action, data?) {
     this.dataDialog = data;
    switch (action) {
      case 'active':
        this.displayActiveModal = true;
        break;
      case 'disable':
        this.displayDisableeModal = true;
        break;
      case 'reactive':
        this.displayReactiveModal = true;
        break;
      default:
        this.constantService.showErrorToast('toast.error_server');
        break;
    }
  }

  getContact() {
    this.constantService.navigateToAddContract();
  }

}
